<template>
  <div class="magidei-shiur-list">
    <div class="row mt-4">
      <b-input-group class="col-md-3">
        <label for="magidei-filter" class="sr-only">{{
          $t("filterLabel")
        }}</label>
        <b-form-input
          id="magidei-filter"
          :placeholder="$_t('KW:filterMagidShiur')"
          v-model="filter"
        ></b-form-input>
        <b-input-group-text :slot="isRTL ? 'prepend' : 'append'">
          <i class="fa fa-search"></i>
        </b-input-group-text>
      </b-input-group>
    </div>
    <magidei-list
      :type="type"
      :magidei-shiur="magideiFiltered"
      :sidebar="sidebar"
    ></magidei-list>
  </div>
</template>
<script>
import MagideiListComponent from "./magideiList.vue";

export default {
  components: {
    MagideiList: MagideiListComponent,
  },
  props: ["type", "sidebar"],
  i18nOptions: {
    namespaces: "components",
    keyPrefix: "magideiShiurList",
  },
  data: () => {
    return {
      magideiShiur: null,
      filter: null,
    };
  },
  created: function () {
    this.getData();
  },
  computed: {
    magideiFiltered: function () {
      if (!this.filter) {
        return this.magideiShiur;
      } else {
        var searchRegex = new RegExp(this.filter, "i");
        return this.magideiShiur.filter(function (magidShiur) {
          return searchRegex.test(magidShiur.name);
        });
      }
    },
  },
  methods: {
    getData: function () {
      this.magideiShiur = null;
      this.loading = true;
      this.$http
        .get("/api/magidei-shiur?type=" + this.type)
        .then((response) => {
          this.magideiShiur = response.data;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.magidei-shiur-list {
  input#magidei-filter {
    border-radius: 10px 0 0 10px;
    height: 40px;
    border-right: none;
  }
  .input-group-text {
    border-radius: 0 10px 10px 0;
    background: transparent;
    border-left: none;
    .fa {
      color: $secondary;
      font-weight: bold;
      font-size: 1rem;
    }
  }
}
</style>